import React from 'react';
import { Play } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import { Markdown } from '@/shared/components/markdown/Markdown';
import type { LessonDTO, LessonTypeConfig } from '../../../core/types/lesson.types';

interface StartScreenProps {
  lesson: LessonDTO;
  config: LessonTypeConfig;
  onStart: () => void;
  isResumed?: boolean;
  completedSlides?: number;
  totalSlides?: number;
}

export const StartScreen: React.FC<StartScreenProps> = ({
  lesson,
  config,
  onStart,
  isResumed = false,
  completedSlides = 0,
  totalSlides = 0,
}) => {
  return (
    <>
      {/* LEFT SIDE - Lesson Image/Video (now on left, 2/3 width) */}
      <div className="lesson-media-panel">
        {lesson.image ? (
          <img
            src={lesson.image}
            alt={lesson.title}
            className="lesson-image-cropped"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center bg-dark">
            <div className="text-center">
              <config.icon className="h-24 w-24 mx-auto text-light opacity-50 mb-4" />
              <p className="text-light text-sm">No image available</p>
            </div>
          </div>
        )}
      </div>

      {/* RIGHT SIDE - Transparent, shows parent background with content (now on right, 1/3 width) */}
      <div className="lesson-split-panel">
        {/* Resume Banner - Shows when continuing incomplete lesson */}
        {isResumed && completedSlides > 0 && totalSlides > 0 && (
          <div className="mb-4 p-4 bg-warning/10 border-l-4 border-warning rounded-lg">
            <div className="flex items-center gap-3">
              <span className="text-2xl">📚</span>
              <div className="flex-1">
                <p className="font-semibold text-dark">Continuă lecția</p>
                <p className="text-sm text-dark mb-1">
                  Ai completat {completedSlides} din {totalSlides} intrebari.
                </p>
                <p className="text-sm text-dark font-medium">
                  Vei continua de la intrebarea {completedSlides + 1}.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Title Box - At top */}
        <div className="lesson-info-box">
          <h1 className="text-2xl font-bold text-foreground text-center leading-tight">
            {lesson.title}
          </h1>
        </div>

        {/* Description Box - In middle */}
        <div className="lesson-info-box">
          {/* B3: descrierea e markdown, fara HTML. */}
          <Markdown source={lesson.description} className="text-sm text-foreground leading-relaxed text-center" />
        </div>

        {/* Start Button - At bottom center */}
        <div className="flex justify-center">
          <Button
            onClick={onStart}
            size="lg"
            className="px-8 py-3 text-base gap-2"
          >
            <Play className="h-5 w-5" />
            {isResumed ? 'Continuă lecția' : 'Începe lecția'}
          </Button>
        </div>
      </div>
    </>
  );
};

export default StartScreen;

